module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.Rub)), (_vm.Kop.length) ? [_vm._v("."), _c('span', {
    staticStyle: {
      "font-size": "80%"
    }
  }, [_vm._v(_vm._s(_vm.Kop))])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f38c0d1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/money.vue
// module id = 511
// module chunks = 0